import type {CandidateBlock} from '../shared/levelBuilder';
import {memo} from 'react';
import {authoredRenderOrder} from '../shared/sourceUnitGroups';
import {getLevelElement} from '../shared/levelElements';
import recreationLandscape from './assets/districts/repairs/recreation-landscape-cutout.svg?url';

const pieceAssets=import.meta.glob('./assets/districts/pieces/**/*.svg',{eager:true,query:'?url',import:'default'}) as Record<string,string>;
const reviewAssets=import.meta.glob('../design/districts-v2/new-themes/*.svg',{eager:true,query:'?url',import:'default'}) as Record<string,string>;

/** Registered immutable assets only; candidate documents never supply URLs. */
export function levelElementAssetUrl(elementId:string,layer:'art'|'foreground'='art'):string {
  const element=getLevelElement(elementId),path=layer==='art'?element.art:element.foreground;
  if(!path)throw new Error(`The supplied element has no ${layer}: ${element.name}`);
  // Presentation repair only: frozen source art, catalog hashes and saved
  // element identities/geometry remain intact for historical reconstruction.
  if(path==='src/assets/districts/pieces/current-v6/recreation/landscape.svg')return recreationLandscape;
  const key=path.startsWith('src/')?`./${path.slice(4)}`:`../${path}`;
  const url=pieceAssets[key]??reviewAssets[key];
  if(!url)throw new Error(`The supplied element art is unavailable: ${element.name}`);
  return url;
}

/** The renderer seam for both authoring and a future approved game consumer.
 * Eligibility and placement transforms come from the shared level resolver. */
function AuthoredStreetArt({candidate,start=0,layer='scenery',schemaVersion=2}:{candidate:CandidateBlock;start?:number;layer?:'scenery'|'foreground';schemaVersion?:1|2|3}) {
  const elements=authoredRenderOrder(candidate,schemaVersion);
  return <g transform={`translate(${start} 0)`} data-level-candidate={layer==='scenery'?candidate.id:undefined} pointerEvents="none">
    {elements.filter(placement=>(getLevelElement(placement.elementId).layer==='foreground')===(layer==='foreground')).map(placement=>{
      const element=getLevelElement(placement.elementId);
      return <image key={placement.id} data-level-element={placement.id} data-level-layer={layer==='foreground'?'foreground':undefined} href={levelElementAssetUrl(placement.elementId)} x={placement.x} y={placement.y} width={element.width} height={element.height}/>;
    })}
    {layer==='foreground'&&elements.map(placement=>{
      const element=getLevelElement(placement.elementId);
      return element.foreground?<image key={placement.id} href={levelElementAssetUrl(placement.elementId,'foreground')} x={placement.x} y={placement.y} width={element.width} height={element.height}/>:null;
    })}
  </g>;
}

export default memo(AuthoredStreetArt);
